import { electronicFormatIBAN, isValidIBAN } from 'ibantools';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js/max';
export var ValidationType;
(function (ValidationType) {
    ValidationType[ValidationType["EMAIL"] = 1] = "EMAIL";
    ValidationType[ValidationType["PHONE"] = 3] = "PHONE";
    ValidationType[ValidationType["DIGITS"] = 4] = "DIGITS";
    ValidationType[ValidationType["LETTERS"] = 5] = "LETTERS";
    ValidationType[ValidationType["POSTAL_CODE"] = 100] = "POSTAL_CODE";
    ValidationType[ValidationType["IBAN"] = 102] = "IBAN";
    ValidationType[ValidationType["DUTCH_PHONE"] = 104] = "DUTCH_PHONE";
})(ValidationType || (ValidationType = {}));
export const fieldTypeFromValidation = (validation) => {
    switch (validation) {
        case ValidationType.EMAIL:
            return 'email';
        case ValidationType.PHONE:
            return 'tel';
        case ValidationType.DIGITS:
            return 'number';
        default:
            return 'text';
    }
};
const validateEmptyString = (value) => {
    return typeof value === 'string' && value.trim() === '';
};
const validateDigits = (value) => {
    return {
        message: `${value} is not a valid digit`,
        reason: 'invalidDigits',
        valid: validateEmptyString(value) || !isNaN(Number(value)),
    };
};
const validatePhone = (value) => {
    return {
        message: `${value} is not a valid phone number`,
        reason: 'invalidPhone',
        valid: validateEmptyString(value) || (typeof value === 'string' && isValidPhoneNumber(value, 'NL')),
    };
};
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const validateEmail = (value) => {
    return {
        message: `${value} is not a valid email`,
        reason: 'invalidEmail',
        valid: validateEmptyString(value) || (typeof value === 'string' && emailRegex.exec(value) !== null),
    };
};
const letterRegex = /^[a-zA-Z]+$/;
const validateLetters = (value) => {
    return {
        message: `${value} contains characters other than letters`,
        reason: 'invalidLetters',
        valid: validateEmptyString(value) || (typeof value === 'string' && letterRegex.exec(value) !== null),
    };
};
const validateIban = (value) => {
    return {
        message: `${value} is not a valid IBAN`,
        reason: 'invalidIban',
        valid: validateEmptyString(value) || (typeof value === 'string' && isValidIBAN(electronicFormatIBAN(value))),
    };
};
const isValidateDutchPhone = (value) => {
    if (typeof value !== 'string') {
        return false;
    }
    try {
        const phoneNumber = parsePhoneNumber(value, 'NL');
        return phoneNumber.isValid() && phoneNumber.country === 'NL';
    }
    catch (_a) {
        return false;
    }
};
const validateDutchPhone = (value) => {
    return {
        message: `${value} is not a valid Dutch phone number`,
        reason: 'invalidDutchPhone',
        valid: validateEmptyString(value) || isValidateDutchPhone(value),
    };
};
const dutchPostalRegex = /^[0-9]{4}\s*[a-z]{2}$/i;
export const validatePostalCode = (value) => {
    return {
        message: `${value} is not a valid postal code`,
        reason: 'invalidPostalCode',
        valid: validateEmptyString(value) || (typeof value === 'string' && dutchPostalRegex.exec(value.trim()) !== null),
    };
};
export const validate = (type) => {
    switch (type) {
        case ValidationType.DIGITS:
            return validateDigits;
        case ValidationType.PHONE:
            return validatePhone;
        case ValidationType.EMAIL:
            return validateEmail;
        case ValidationType.LETTERS:
            return validateLetters;
        case ValidationType.IBAN:
            return validateIban;
        case ValidationType.DUTCH_PHONE:
            return validateDutchPhone;
        case ValidationType.POSTAL_CODE:
            return validatePostalCode;
        default:
            return null;
    }
};
const formatPhone = (value) => {
    try {
        const phoneNumber = parsePhoneNumber(value, 'NL');
        if (!phoneNumber.isValid()) {
            return value;
        }
        if (phoneNumber.country === 'NL') {
            return phoneNumber.formatNational();
        }
        else {
            return phoneNumber.formatInternational();
        }
    }
    catch (_a) {
        return value;
    }
};
export const formatValueForValidation = (type, value) => {
    switch (type) {
        case ValidationType.PHONE:
        case ValidationType.DUTCH_PHONE:
            return formatPhone(value);
        default:
            return value;
    }
};
